import type { KuxDms } from '@kaltura-ott/tvpil';

import type { ExponeaUiButton, ExponeaUiResponse } from '..';

const BUTTON_CLOSE_TYPE = 'close';
const DEFAULT_CLOSE_BUTTON: ExponeaUiButton = {
  position: 'down',
  text: 'Close',
  type: 'close',
  link: null,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseExponeaResponse = (res: any, dms: KuxDms): ExponeaUiResponse | null => {
  const exponeaUi = res.response as ExponeaUiResponse;

  if (!exponeaUi || !exponeaUi.display) {
    return null;
  }

  if (!exponeaUi.buttons.find((it) => it.type === BUTTON_CLOSE_TYPE)) {
    exponeaUi.buttons.push(DEFAULT_CLOSE_BUTTON);
  }

  if (!exponeaUi.time) {
    if (!dms.exponea?.defaultDisplayTimeInSeconds) {
      console.log('Exponea dms.exponea.defaultDisplayTimeInSeconds is empty');
    } else {
      exponeaUi.time = dms.exponea.defaultDisplayTimeInSeconds;
    }
  }

  return exponeaUi;
};
